import {
  SnippetElement,
  defineElement,
  on
} from "./chunk-POAMU4SL.js";
import {
  __decorateClass
} from "./chunk-XDKWOSVF.js";

// src/snippets/pb-shop-linked-products/pb-shop-linked-products.ts
var PbShopLinkedProducts = class extends SnippetElement {
  handleClick(elm) {
    window.location.href = elm.value;
  }
};
__decorateClass([
  on("change", "select")
], PbShopLinkedProducts.prototype, "handleClick", 1);
PbShopLinkedProducts = __decorateClass([
  defineElement("pb-shop-linked-products")
], PbShopLinkedProducts);
export {
  PbShopLinkedProducts
};
